import React, { HTMLAttributes } from 'react'

import clsx from 'clsx'

export type ActionBarProps = { wrap?: boolean; wrapperId?: string } & HTMLAttributes<HTMLDivElement>

export function ActionBar({ children, className, wrap, wrapperId, ...props }: ActionBarProps) {
  return (
    <div className={clsx(className, 'border-border-muted border-b')} {...props}>
      <div
        className={clsx(
          'm-auto grid max-w-screen-2xl grid-cols-1 flex-col gap-y-4 p-6 md:flex md:flex-row md:items-center md:justify-between',
          { 'flex-wrap': wrap }
        )}
        id={wrapperId}
      >
        {children}
      </div>
    </div>
  )
}
